import { v4 as uuidv4 } from "uuid";

import { ChatMessage } from "../api/models";

// Helper function to format dates with proper timezone handling
export const formatMessageDate = (dateString: string): string => {
  let date: Date;

  if (dateString.endsWith("Z")) {
    // If it has explicit timezone info (like "2025-09-30T12:36:53.179194Z"), parse directly
    date = new Date(dateString);
  } else if (dateString.includes("T")) {
    // Backend format: "2025-09-30T12:36:53.179194" - treat as UTC by appending Z
    date = new Date(dateString + "Z");
  } else {
    // Fallback for other formats - assume UTC
    date = new Date(dateString + "Z");
  }

  // Check if the date is invalid
  if (isNaN(date.getTime())) {
    console.warn("Invalid date string:", dateString);
    return "Invalid Date";
  }

  // Convert to local timezone and format
  return date.toLocaleString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
    timeZoneName: "short",
  });
};

export const createErrorMessage = (error: string): ChatMessage => ({
  role: "error",
  content: error,
  id: uuidv4(),
  date: new Date().toISOString(),
});

export const parseToolContent = (content: any) => {
  try {
    return typeof content === "string" ? JSON.parse(content) : content;
  } catch (e) {
    console.error("Failed to parse tool content:", e);
    return {};
  }
};
